import dayjs from 'dayjs';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, { createContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { fetchDimensionsRequest, fetchScopesRequest, getSalesConversionName, getSalesConversionObject, setDateRangeReports, setListSegmentReport } from '../../../../actions/subscriber';
import { callTokenApi } from '../../../../apiCaller';
import { API_CLIENT_DEFAULT_REPORT_DATE_RANGE_CONFIGS, API_GET_ECO_ITEM_CATEGORIES, BQ_JOB_STATUS, CLIENT_GET_SAVED_REPORT_BY_ID, CLIENT_GET_SAVED_VIEWS, DEFAULT_DATE_FORMAT, FILTER_DATA_TYPES, REPORT_DATA_TYPES, REPORT_NAMES, ROUTE_EXPLORE_DATA, SALES_FORCE_OBJECT, SESSION_STORAGE_REPORT_DATE_RANGE } from '../../../../constants';
import {
     CUSTOM_REPORT_SCOPED,
     DATE_SCOPE,
     MERGE_REPORT_NAME,
     PERIOD_TYPES,
     PERIOD_TYPES_NEW,
     PROPERTY_TYPES,
     REPORT_TAB_TYPES,
     REPORT_TYPE,
     ROLLING_DATE_RANGE,
     SAVE_REPORT_DATE_OPTION,
     SCOPED,
     SECTION_REPORT,
     SEGMENT_PROPERTY_OPTION,
     VARIABLE_OPERATORS_REPORT,
     WEIGHT_TYPES,
} from '../../../../constants/analytics';
import { camelCase, camelCaseCustomProperties, capitalizeFirstLetter, decodeObj, generateCustomDimensionName, getSectionCustomPropertiesDefault, getSegmentField, handleAddMetricSalesConversion, handleAddMetricSalesConvNameIndividual } from '../../../../utils';
import CenterSpinner from '../../../general/Loadings/CenterSpinner';
import ChartReport from './chart-report';
import CustomDatePicker from './CustomDatePicker';
import MenuReport from './MenuReport';
import ReportTableV2 from './ReportTable-V2';
import ScopeDropdown from './ScopeDropdown';
import useFirstFetchReportData from './useFirstFetchReportData';
import useUtmArray from './useUtmArray';
import AddSegments from './segments/AddSegments';
import { VIEW_TYPE } from '../../../../constants/reportView';
import { useHistory } from "react-router-dom";
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import CSubheader from '../../../migration/CSubheader';
import BreadcrumbRouter from '../../../general/breadcrumb/BreadcrumbRouter';
import { getDefaultFieldReport } from '../../../../utils/UtilReport';
dayjs.extend(quarterOfYear)

export const EventExplorerContext = createContext();
export const handleGetOption = ({ option, type = '', filter = [], reportName, defaultArr, weight, menuFilter, isDefaultMetrics = false, isSectionMenu, reportType }) => {
     let newOptions = [];
     let optionReport = option;
     const hasDefaultArrReports = [
          REPORT_NAMES.UTM_REPORT,
          REPORT_NAMES.ALL_PAGE_REPORT,
          REPORT_NAMES.LANDING_PAGE_REPORT,
          REPORT_NAMES.EXIT_PAGE_REPORT,
          REPORT_NAMES.BY_LANDING_PAGE_REPORT,
          REPORT_NAMES.BY_UTM_REPORT,
          REPORT_NAMES.FORM_CATEGORY_REPORT,
          REPORT_NAMES.SOURCE_REPORT,
          REPORT_NAMES.BY_SOURCE_REPORT,
          REPORT_NAMES.CHANNEL_REPORT,
          REPORT_NAMES.CONVERSION_SOURCE_ATTRIBUTION_REPORT,
          REPORT_NAMES.ECOMMERCE_ITEMS,
          REPORT_NAMES.BY_CONVERSION,
          REPORT_NAMES.BY_PROPERTY,
          REPORT_NAMES.SALES_CONVERSION_BY_CONVERSION,
          REPORT_NAMES.SALES_CONVERSION_BY_PROPERTY,
          ...MERGE_REPORT_NAME
     ];
     if (isDefaultMetrics && type === 'defaultMetric') {
          optionReport = option.filter((_item) => _item.isDefault);
     }

     if ((hasDefaultArrReports.includes(reportName) || [REPORT_TYPE.SALE_FORCE, REPORT_TYPE.CUSTOM_EXTERNAL].includes(reportType)) && type === 'defaultDimension') {
          optionReport = defaultArr;
     }
     // add select all
     if (type === 'option' && menuFilter !== 'filterDimension' && ![REPORT_NAMES.BY_CONVERSION, REPORT_NAMES.BY_PROPERTY, REPORT_NAMES.SALES_CONVERSION_BY_CONVERSION, REPORT_NAMES.SALES_CONVERSION_BY_PROPERTY].includes(reportName) && !isSectionMenu && ![REPORT_TYPE.SALE_FORCE, REPORT_TYPE.CUSTOM_EXTERNAL].includes(reportType) && !([REPORT_NAMES.EVENT_DETAILS, REPORT_NAMES.CONVERSION_EVENTS, REPORT_NAMES.SESSION_DETAILS, REPORT_NAMES.USER_DETAILS, REPORT_NAMES.PERSON_DETAILS, REPORT_NAMES.COMPANY_DETAILS].includes(reportName) && menuFilter === 'filterProperty')) {
          newOptions.push({ label: 'Select All', value: '' });
     }
     optionReport?.forEach((item) => {
          // report conversion source attribution case 1: not select weights default case 2: weights select when model (weight) have select
          if (
               reportName === REPORT_NAMES.CONVERSION_SOURCE_ATTRIBUTION_REPORT &&
               (!WEIGHT_TYPES.find((el) => el.key === item.key) || (weight?.value && item.key === weight.value))
          ) {
               if (type === 'weight') {
                    newOptions.push({ label: item.label, key: item.key });
               } else {
                    newOptions.push({ label: item.label, value: item.key });
               }
          } else if (reportName !== REPORT_NAMES.CONVERSION_SOURCE_ATTRIBUTION_REPORT) {
               const newOption = { label: item.label, value: item.key, section: item?.section || SECTION_REPORT.DEFAULT, description: item?.description }
               if (item?.sectionParent) {
                    newOption.sectionParent = item?.sectionParent
               }
               newOptions.push(newOption);
          }
     });
     // select all item show no options
     if (filter.length > 0 && newOptions.some((item) => item.label === 'Select All') && filter.length === newOptions.length - 1) {
          newOptions = [];
     }
     return newOptions;
};

export const handleGetSortSegment = ({ listSegmentReportApply, filterMetric }) => {
     if (!filterMetric || filterMetric.length === 0) {
          return {};
     }

     if (listSegmentReportApply.length === 0) {
          return {
               fieldName: filterMetric[0].value,
               isDesc: true,
          };
     }
     if (listSegmentReportApply.length > 0) {
          listSegmentReportApply = listSegmentReportApply.sort((a, b) => new Date(a.orderBy) - new Date(b.orderBy));
          const newFilterMetrics =
               filterMetric?.map((e) => ({
                    value: e.value ? `${getSegmentField(listSegmentReportApply[0].id, e.value)}` : `${getSegmentField(listSegmentReportApply[0].id, e.key)}`,
                    label: e.label,
               }));
          if (newFilterMetrics[0]) {
               return {
                    fieldName: newFilterMetrics[0].value,
                    isDesc: true,
               };
          } else {
               return {}
          }
     }
};

const useDataParam = () => {
     const location = useLocation();
     let dynamicKey = new URLSearchParams(location.search).get('dynamicKey');
     let staticKey = new URLSearchParams(location.search).get('staticKey');
     let dataParamValue;

     if (dynamicKey && staticKey) {
          dataParamValue = true;
     }

     return dataParamValue;
};

const getDynamicFieldInReport = ({
     dimensions,
     properties,
     customDimensionsTemp,
     reportName,
     scoped,
     scopes,
     showTargetAccount,
     listDynamicFields,
     reportType,
     customObjectSF,
     listSegmentReportApply,
     filterProperties,
     setFilterProperties,
     filterLinks,
     intentProperties = [],
     customDimensionIds,
     externalObject,
     propertiesOptional,
     metricsOptional,
}) => {
     // DL-1786
     let customDimensions = [];
     const customDimensionInfo = [];
     let propertiesDynamic = [];
     const segmentProperties = [];
     // array need check custom properties, includes: dimensions, properties
     const arrayNeedCheck = [...dimensions, ...properties];
     const sameNamePropertyArray = [];
     const isExploreDataReport = window.location.pathname.includes(ROUTE_EXPLORE_DATA);

     customDimensionsTemp.forEach((item) => {
          const scopeItem = [];
          let target = '';
          let propertyType = '';
          let isSameNameProperty = false;
          const removeItem = ['ads_storage', 'Regional Consent Rule'].includes(item.name) && scoped === SCOPED.EVENT;
          const removeIds = (['Session ID', 'User ID', 'Person ID', 'Company ID'].includes(item.name) || !item.isCustom) && MERGE_REPORT_NAME.includes(reportName);
          let removeTargetAccount = !showTargetAccount && item.name === 'Target Account Domain';
          const sameProperty = arrayNeedCheck.find((el) => item.isCustom === false && el.label === item.name); // the same label
          const sameKeyProperty = arrayNeedCheck.find((el) => item.isCustom === false && el.key === camelCase(item.name)); // the same path
          const sameNameProperty = customDimensionsTemp.find(
               (el) => item.isCustom === false && el.name !== item.name && camelCase(el.name) === camelCase(item.name)
          ); // the same path

          if (item.queryStatus !== BQ_JOB_STATUS.DONE) {
               return;
          }

          const allTarget = {};
          let scopedFilter = filterLinks[0]?.scoped;

          item.availableScopes.forEach((el) => {
               let scope = scopes.find((e) => e.id === el.id);
               let scopedSF = [SCOPED.SF_ACCOUNT, SCOPED.SF_CAMPAIGN, SCOPED.SF_CONTACT, SCOPED.SF_CONTRACT, SCOPED.SF_EVENT, SCOPED.SF_LEAD, SCOPED.SF_OPPORTUNITY, SCOPED.SF_ORDER, SCOPED.SF_QUOTE].find((e) => e === el.id);

               propertyType = el.propertyType;

               if (customObjectSF) {
                    scopedSF = customObjectSF === el.id ? SCOPED.SF_CUSTOM_OBJECT : '';
               }

               if (reportType === REPORT_TYPE.CUSTOM_EXTERNAL && customObjectSF) {
                    scopedSF = customObjectSF === el.id ? SCOPED.CUSTOM_EXTERNAL_OBJECT : '';
               }

               if (scope) {
                    scopeItem.push(scope.name);
                    allTarget[CUSTOM_REPORT_SCOPED[scope.name]] = el.target
               }

               if (scope?.name.includes(scoped)) {
                    target = el.target;
               }
               if (scopedSF) {
                    scopeItem.push(scopedSF);
               }

               if (scopedSF?.includes(scoped)) {
                    target = el.target;
               }
               // Handle Sales Conversion scope for SALES_CONVERSION_EVENTS
               if (el.id === 'Sales Conversion' && reportName === REPORT_NAMES.SALES_CONVERSION_EVENTS) {
                    scopeItem.push(scoped);
                    target = el.target;
               }
               if (scopedFilter && customDimensionsTemp.some((el) => generateCustomDimensionName(el.name) === generateCustomDimensionName(item.name) && filterLinks.some((el) => el.type === generateCustomDimensionName(item.name)))) {
                    if (scopedFilter) {
                         scopeItem.push(scopedFilter);
                    }

                    if (scopedFilter?.includes(scoped)) {
                         target = el.target;
                    }
               }
          });
          if (scopeItem.find((e) => e.includes(scoped)) && sameNameProperty) {
               sameNamePropertyArray.push(item);
          }
          if (sameNamePropertyArray.length > 1) {
               // name custom report dup or many dup
               const searchTerm = camelCase(item.name);
               const searchRegex = new RegExp(searchTerm, 'i');
               const occurrences = sameNamePropertyArray.filter((obj) =>
                    Object.values(obj).some((value) => typeof value === 'string' && value.match(searchRegex))
               );
               const countOccurrences = occurrences.length || 0;
               if (countOccurrences > 1) {
                    isSameNameProperty = true;
               }
          }

          const isWebConversion = item.availableScopes.some((item) => item.isWebConversion);
          const existScoped = scopeItem.find((e) => {
               const dimensionScope = CUSTOM_REPORT_SCOPED[e] || e;
               return dimensionScope === scoped
          })
          const addCustomProperty = existScoped && !sameProperty && !sameKeyProperty && !isSameNameProperty && !removeItem && !removeTargetAccount && !removeIds;
          if (
               (reportName !== REPORT_NAMES.CONVERSION_EVENTS && addCustomProperty) ||
               (reportName === REPORT_NAMES.CONVERSION_EVENTS && isWebConversion) ||
               ((reportName === REPORT_NAMES.BY_CONVERSION || reportName === REPORT_NAMES.BY_PROPERTY) && isWebConversion) ||
               ([REPORT_TYPE.SALE_FORCE, REPORT_TYPE.CUSTOM_EXTERNAL].includes(reportType) && target)
          ) {
               const sectionPro = getSectionCustomPropertiesDefault(item, scoped);
               customDimensions.push({
                    key: generateCustomDimensionName(item.name),
                    label: item.name,
                    description: item?.description,
                    section: item.isCustom ? SECTION_REPORT.CUSTOM_PROPERTIES : sectionPro?.section,
                    sectionParent: item.isCustom ? '' : sectionPro?.sectionParent,
               });

               customDimensionInfo.push({
                    ...item,
                    properties: generateCustomDimensionName(item.name),
                    target: target,
                    allTarget,
                    propertyType
               });
          } else if (scopedFilter && customDimensionsTemp.some((el) => generateCustomDimensionName(el.name) === generateCustomDimensionName(item.name) && filterLinks.some((el) => el.type === generateCustomDimensionName(item.name)))) {
               customDimensionInfo.push({
                    ...item,
                    properties: generateCustomDimensionName(item.name),
                    target: target,
                    allTarget,
                    propertyType
               });
          } else if (customDimensionIds && !customDimensionInfo.some((el) => el.id === item.id) && customDimensionIds.includes(item.id)) {
               customDimensionInfo.push({
                    ...item,
                    properties: generateCustomDimensionName(item.name),
                    target: target,
                    allTarget,
                    propertyType
               });
          }
     });

     if (intentProperties?.length > 0 && [REPORT_NAMES.PERSON_DETAILS, REPORT_NAMES.COMPANY_DETAILS].includes(reportName)) {
          intentProperties.forEach((item) => {
               if (!customDimensions.some((el) => el.key === item.key) && item.object === scoped.toLowerCase()) {
                    customDimensions.push({
                         key: generateCustomDimensionName(`${item.name}_intent`),
                         label: item.name,
                         description: item?.description,
                         section: SECTION_REPORT.INTENT_PROPERTIES,
                    });
               }
          });
     }

     if (listDynamicFields?.properties.length > 0) {
          listDynamicFields.properties.forEach((p) => {
               if (!customDimensions.some((nd) => nd.key === p.key)) {
                    propertiesDynamic.push(p);
               }
          })
     }

     if (customDimensions.length > 0) {
          customDimensions = customDimensions.sort((a, b) => a.key.localeCompare(b.key));
     }

     if (
          customDimensions.length > 0 &&
          [
               REPORT_NAMES.CONSENT_REPORT,
               REPORT_NAMES.GEOGRAPHY_REPORT,
               REPORT_NAMES.DEVICE_REPORT,
               REPORT_NAMES.BROWSER_REPORT,
               REPORT_NAMES.CHANNEL_REPORT,
               REPORT_NAMES.SOURCE_REPORT,
               REPORT_NAMES.UTM_REPORT,
               REPORT_NAMES.REFERRALS_REPORT,
               REPORT_NAMES.NEW_RETURNING_REPORT,
               REPORT_NAMES.SESSION_COUNT_REPORT,
               REPORT_NAMES.SESSION_DURATION_REPORT,
               REPORT_NAMES.CONVERSION_COUNT_REPORT,
               REPORT_NAMES.PEOPLE_AND_USER_COUNT_REPORT,
               REPORT_NAMES.PEOPLE_COUNT_REPORT,
               REPORT_NAMES.ALL_PAGE_REPORT,
               REPORT_NAMES.LANDING_PAGE_REPORT,
               REPORT_NAMES.EXIT_PAGE_REPORT,
               REPORT_NAMES.ENTRANCE_AND_EXIT_REPORT,
               REPORT_NAMES.ALL_CONVERSION_REPORT,
               REPORT_NAMES.BY_URL_REPORT,
               REPORT_NAMES.BY_SOURCE_REPORT,
               REPORT_NAMES.BY_UTM_REPORT,
               REPORT_NAMES.BY_LANDING_PAGE_REPORT,
               REPORT_NAMES.CONVERSION_SOURCE_ATTRIBUTION_REPORT,
               // REPORT_NAMES.ECOMMERCE_PURCHASE_FLOW,
               // REPORT_NAMES.ECOMMERCE_ITEMS,
               REPORT_NAMES.ECOMMERCE_PURCHASE_ACTIVITY,
               // REPORT_NAMES.ECOMMERCE_PURCHASE_TRANSACTION,
               REPORT_NAMES.BY_CONVERSION,
               REPORT_NAMES.BY_PROPERTY,
               ...MERGE_REPORT_NAME
          ].includes(reportName)
     ) {
          return { newDimensions: dimensions.concat(customDimensions), newProperties: [], customDimensionInfo: customDimensionInfo };
     }

     // Add property Segments for explore data report
     if (isExploreDataReport) {
          if (listSegmentReportApply.length > 1) {
               segmentProperties.push(SEGMENT_PROPERTY_OPTION);
          } else {
               const segmentFilterPropertyExists = filterProperties.some((property) => property.value === SEGMENT_PROPERTY_OPTION.key);
               if (segmentFilterPropertyExists) {
                    setFilterProperties((prevFilterProperties) => prevFilterProperties.filter((property) => property.value !== SEGMENT_PROPERTY_OPTION.key));
               }
          }
     }

     const originProperties = [...properties];

     let _dimensions = [
          ...dimensions.map((item) => ({
               ...item,
               label:
                    reportType === REPORT_TYPE.CUSTOM_EXTERNAL &&
                         externalObject &&
                         item.key === 'crmCustomObjectID'
                         ? `CRM ${externalObject?.object} ID`
                         : item.label,
          })),
     ];

     if (reportName === REPORT_NAMES.CUSTOM_EXTERNAL_OBJECT) {
          const dimensionExternal = externalObject?.uniqueIdFields?.length > 0 ? externalObject?.uniqueIdFields.map((el) => ({ key: el.name, label: `CRM ${capitalizeFirstLetter(el.label)}`, section: SECTION_REPORT.SYSTEM_FIELDS })) : [];
          if (dimensionExternal?.length > 0) {
               _dimensions.push(...dimensionExternal);
          }
          if (externalObject?.characteristicHasRevenue) {
               originProperties.push(...(propertiesOptional[PROPERTY_TYPES.REVENUE] || []));
          }

          if (externalObject?.characteristicIsCompany) {
               originProperties.push(...(propertiesOptional[PROPERTY_TYPES.COMPANY] || []));
          }

          if (externalObject?.characteristicIsPerson) {
               originProperties.push(...(propertiesOptional[PROPERTY_TYPES.PERSON] || []));
          }

          if (!externalObject?.characteristicHasRevenue && !externalObject?.characteristicIsCompany && !externalObject?.characteristicIsPerson) {
               originProperties.push(...(propertiesOptional[PROPERTY_TYPES.NO_OPTIONS] || []));
          }
     }

     if (segmentProperties.length) {
          originProperties.push(...segmentProperties);
     }

     if (
          customDimensions.length > 0 &&
          ([
               REPORT_NAMES.SESSION_DETAILS,
               REPORT_NAMES.USER_DETAILS,
               REPORT_NAMES.PERSON_DETAILS,
               REPORT_NAMES.COMPANY_DETAILS,
               REPORT_NAMES.EVENT_DETAILS,
               REPORT_NAMES.CONVERSION_EVENTS,
               REPORT_NAMES.BY_CONVERSION,
               REPORT_NAMES.BY_PROPERTY,
               REPORT_NAMES.ECOMMERCE_PURCHASE_TRANSACTION,
               REPORT_NAMES.SALES_CONVERSION_EVENTS,
          ].includes(reportName) || [REPORT_TYPE.SALE_FORCE, REPORT_TYPE.CUSTOM_EXTERNAL].includes(reportType))

     ) {
          return { newDimensions: _dimensions, newProperties: originProperties.concat(customDimensions).concat(propertiesDynamic), customDimensionInfo: customDimensionInfo };
     } else {
          return { newDimensions: _dimensions, newProperties: originProperties.concat(propertiesDynamic), customDimensionInfo: customDimensionInfo };
     }
};

const getDateScopeReport = ({ reportDetailData, scoped, reportName, customExternalObjectReport, objectID }) => {
     let dateScopes = (reportDetailData && (reportDetailData.dateScopes || (reportDetailData[scoped]?.dateScopes))) || [];
     if (reportName === REPORT_NAMES.CUSTOM_EXTERNAL_OBJECT) {
          const customExternalObject = customExternalObjectReport.find((item) => item.id === objectID)
          if (customExternalObject?.characteristicHasRevenue) {
               dateScopes = [...dateScopes, DATE_SCOPE.CLOSED_DATE, DATE_SCOPE.FORECAST_CLOSED_DATE]
          }
     }
     return dateScopes
}
const EventExplorer = ({ title, reportName, reportType, recordProfile, filterRecord, isFecthTableEvent = true, customObjectSF, SFObject, objectID }) => {
     const dispatch = useDispatch();
     const routes = useSelector(state => state.subscriber.routes);
     const activeAccount = useSelector((state) => state.subscriber.activeAccount);
     const reportParamValue = useSelector((state) => state.subscriber.reportParamValue);
     const isLinkParams = useDataParam();
     const dataParamValue = isLinkParams ? reportParamValue : null;
     const { segmentId: paramSegmentId, customDimensionIds, saleConversionDimensionClick } = dataParamValue || {};
     const location = useLocation();
     const reportDetailData = REPORT_DATA_TYPES[reportName];
     const primaryObject = useSelector((state) => state.subscriber.primaryObjectList);
     const secondaryObject = useSelector((state) => state.subscriber.secondaryObjectList);
     const salesConversionName = useSelector((state) => state.subscriber.salesConversionNameList);
     const customExternalObjectReport = useSelector((state) => state.subscriber.customExternalObjectReport);
     const externalObject = customExternalObjectReport.find((item) => item.id === objectID);
     const externalObjectReport = useSelector((state) => state.subscriber.externalObjectReport);
     const customExternalDataSources = useSelector((state) => (state.subscriber.accountExternalData ? state.subscriber.accountExternalData.customSources : null));
     const customExternal = customExternalDataSources?.filter((source) => source.createdAccountId === activeAccount.id);
     const salesForceObjects = externalObjectReport.filter((report) => report.appearInReport);
     const customExternalObjects = customExternalObjectReport.filter((report) => customExternal?.length > 0 ? customExternal.some((el)=> el?.accountExternalData?.externalDataId === report?.externalId && el?.accountExternalData?.status) : false)
          .filter((report) => report.appearInReport);
     const [payloadReportExplorer, setPayloadReportExplorer] = useState();
     const [payloadReportFilter, setPayloadReportFilter] = useState();
     const [rerunValueChange, setRerunValueChange] = useState(false);

     const reportSalesConversion = reportName === REPORT_NAMES.SALES_CONVERSION_BY_CONVERSION || reportName === REPORT_NAMES.SALES_CONVERSION_BY_PROPERTY || reportName === REPORT_NAMES.SALES_CONVERSION_EVENTS

     const isChangeScope = useRef(false);
     const [scoped, setScoped] = useState(
          reportName === 'sessionDurationReport' || reportName === 'conversionCountReport'
               ? Object.keys(REPORT_DATA_TYPES[reportName])[1]
               : Object.keys(REPORT_DATA_TYPES[reportName])[0]
     );

     const intentPropertiesState = useSelector((state) => state.subscriber.intentProperties);
     const intentProperties = intentPropertiesState.filter((item) => item?.object === scoped.toLowerCase());

     useEffect(() => {
          if (reportSalesConversion || [REPORT_TYPE.SALE_FORCE, REPORT_TYPE.CUSTOM_EXTERNAL].includes(reportType)) {
               dispatch(getSalesConversionObject(activeAccount.id));
               dispatch(getSalesConversionName(activeAccount.id));
          }
     }, [activeAccount.id, reportName]) //eslint-disable-line

     const metricSecondaryObject = reportSalesConversion ? handleAddMetricSalesConversion(secondaryObject, reportName) : [];
     const metricIndividualSalesConversion = reportSalesConversion ? handleAddMetricSalesConvNameIndividual(salesConversionName, reportName) : [];

     // list Metric By Object Sales Conversion Report
     function updateMetrics(metricsSource, filterKey) {
          if (metricsSource && reportSalesConversion) {
               reportDetailData[scoped].metrics = reportDetailData[scoped].metrics.filter(metric => !metric[filterKey]);

               metricsSource.forEach(item => {
                    if (!reportDetailData[scoped].metrics.some(metric => metric.key === item.key)) {
                         reportDetailData[scoped].metrics.push(item);
                    }
               });
          }
     }

     const history = useHistory();

     const _dateScopes = getDateScopeReport({ reportDetailData, scoped, reportName, customExternalObjectReport, objectID });
     const RECORD_PROFILE_DATE_SCOPES = [DATE_SCOPE.EVENT_ACTIVITY, DATE_SCOPE.CREATION_DATE, DATE_SCOPE.LAST_CONVERSION_DATE, DATE_SCOPE.LAST_ACTIVE_DATE];
     const dateScopes = (recordProfile && reportName === REPORT_NAMES.PERSON_DETAILS)
          ? _dateScopes.filter((scope) => RECORD_PROFILE_DATE_SCOPES.includes(scope))
          : _dateScopes;
     const dateScopeOptions = dateScopes.map((item) => ({ label: item, value: item }));

     const getInitialDateScope = () => {
          if (dataParamValue?.filters?.some((filter) => MERGE_REPORT_NAME.includes(filter?.reportName) && !filter?.object)) {
               if (dataParamValue?.filters?.some((filter) => filter?.isNewCount)) {
                    return dateScopes.includes(DATE_SCOPE.CREATION_DATE) ? DATE_SCOPE.CREATION_DATE : DATE_SCOPE.EVENT_ACTIVITY;
               }

               if (dataParamValue?.filters?.some((filter) => filter?.scoped === scoped)) {
                    return dataParamValue?.dateScope || DATE_SCOPE.EVENT_ACTIVITY;
               }

               return dataParamValue?.filters?.[0]?.dateScope || DATE_SCOPE.EVENT_ACTIVITY;
          }

          if (dataParamValue && dataParamValue?.dateScope && ![REPORT_TYPE.SALE_FORCE, REPORT_TYPE.CUSTOM_EXTERNAL].includes(reportType)) {
               return !(dataParamValue?.filters?.some((filter) => [REPORT_TYPE.SALE_FORCE, REPORT_TYPE.CUSTOM_EXTERNAL].includes(filter?.reportType))) ? dataParamValue?.dateScope : DATE_SCOPE.EVENT_ACTIVITY
          }
          return dateScopes.includes(DATE_SCOPE.CREATION_DATE) ? DATE_SCOPE.CREATION_DATE : DATE_SCOPE.EVENT_ACTIVITY
     }

     const initDateScope = getInitialDateScope();

     let {
          dimensions,
          properties,
          metrics,
          defaultDimensions = [],
          defaultWeight,
          isDefaultMetrics,
          propertiesOptional,
          metricsOptional,
     } = reportType ? REPORT_DATA_TYPES[reportName][scoped] : REPORT_DATA_TYPES[reportName];
     const showTargetAccount = activeAccount.usingTargetAccount;
     if (!showTargetAccount) {
          properties = properties.filter((item) => !['isTargetAccount', 'targetAccountDomain', 'targetAccountGroups'].includes(item.key))
     }
     const {
          isConversionName,
          isConversionNameRate,
          isConversionAllReport,
          isSalesConversionName,
     } = reportType ? REPORT_DATA_TYPES[reportName][scoped] : REPORT_DATA_TYPES[reportName];
     const [conversionNameMetric, setConversionNameMetric] = useState([]);
     const [conversionName, setConversionName] = useState([]);
     const [utmArray, setUtmArray] = useState([]);
     const [listDynamicFields, setListDynamicFields] = useState({ dimensions: [], properties: [], metrics: [] });
     const [eCoItemCategories, setECoItemCategories] = useState([]);
     const [externalObjectMetric, setExternalObjectMetric] = useState([]);
     const [unRelated, setUnRelated] = useState(false);
     const user = useSelector((state) => state.theme.user);
     const dateRangeReports = useSelector((state) => state.subscriber.dateRangeReports);
     const customDimensions = useSelector((state) => state.subscriber.customReport.dimensions);
     const listSegmentReport = useSelector((state) => state.subscriber.listSegmentReport);
     const listSegment = useSelector((state) => state.subscriber.listSegment);
     const scopes = useSelector((state) => state.subscriber.customReport.scopes);
     const dayjsNow = dayjs().tz(activeAccount.timeZone);
     const initListSegmentReportApply = recordProfile ? [] : typeof paramSegmentId !== 'undefined' ? listSegmentReport.filter((el) => el.id === paramSegmentId) : listSegmentReport.filter((item) => item.apply);
     const [listSegmentReportApply, setListSegmentReportApply] = useState(initListSegmentReportApply);
     const [listChartSegmentApply, setListChartSegmentApply] = useState([]);
     const [reportView, setReportView] = useState({});
     const [salesConversionDimension, setSalesConversionDimension] = useState([])
     const reportViewParam = new URLSearchParams(location.search).get('reportView');
     const showNewNavigation = localStorage.getItem('showNewNavigation') || window.location.search.includes('?show-navigation=1');
     const disableSort = reportName === REPORT_NAMES.ECOMMERCE_PURCHASE_FLOW;
     const parseParams = decodeObj(reportViewParam);
     let defaultDateRange = {
          selection: {
               startDate: dayjsNow.subtract(1, 'day'),
               endDate: dayjsNow.subtract(0, 'day'),
          },
     };
     useEffect(() => {
          if (reportSalesConversion) {
               setSalesConversionDimension(customDimensions.filter((dimension) => dimension.availableScopes.some((scope) => scope.id === 'Sales Conversion') && !!dimension.status) || [])
          }
     }, [activeAccount.id, reportName, scoped, customDimensions]) //eslint-disable-line
     // list Dimension Sales Conversion Report
     function updateDimensions(customDimension) {
          if (customDimension && reportSalesConversion) {
               reportDetailData[scoped].dimensions = reportDetailData[scoped].dimensions.filter((item) => item.section !== 'Custom Properties')
               customDimension.forEach(item => {
                    if (!reportDetailData[scoped].dimensions.some(dimension => dimension.key === camelCaseCustomProperties(item.name))) {
                         reportDetailData[scoped].dimensions.push({ key: `${camelCaseCustomProperties(item.name)}`, label: item.name, section: 'Custom Properties' });
                    }
               });
          }
     }

     if (reportSalesConversion && reportName !== REPORT_NAMES.SALES_CONVERSION_EVENTS) {
          updateDimensions(salesConversionDimension)
     }
     if (reportSalesConversion) {
          if (reportType !== REPORT_TYPE.EXPLORE_DATA || reportName !== REPORT_NAMES.SALES_CONVERSION_EVENTS) {
               updateMetrics(metricSecondaryObject, 'object');
               updateMetrics(metricIndividualSalesConversion, 'conversionID');
          }
     }

     const [filterProperties, setFilterProperties] = useState(handleGetOption({ option: properties.filter((_p) => _p.isDefault) }));
     const [defaultConfig, setDefaultConfig] = useState({})

     useEffect(() => {
          if (isEmpty(dateRangeReports)) {
               dispatch(setDateRangeReports(defaultDateRange));
          }
     }, []); //eslint-disable-line
     useUtmArray({
          utmArray,
          setUtmArray,
          listDynamicFields,
          setListDynamicFields,
          dimensions,
          reportName,
          dateRangeReports,
          reportType,
          customObjectSF,
          SFObject,
          objectID,
     });

     const accountId = activeAccount.id;
     const customDimensionsTemp = customDimensions.filter((item) => item.status);

     const { newDimensions, newProperties, customDimensionInfo } = getDynamicFieldInReport({
          dimensions,
          properties,
          customDimensionsTemp,
          reportName,
          scoped,
          scopes: [...scopes, []],
          showTargetAccount,
          listDynamicFields,
          reportType,
          customObjectSF,
          listSegmentReportApply,
          filterProperties,
          setFilterProperties,
          filterLinks: dataParamValue && Array.isArray(dataParamValue?.filters) ? dataParamValue?.filters : [],
          intentProperties,
          customDimensionIds,
          externalObject,
          propertiesOptional,
          metricsOptional,
     });
     const [reloadTable, setReloadTable] = useState(false);

     const [tableData, setTableData] = useState([]);
     const [metricsStepForm, setMetricsStepForm] = useState([]);
     const [filterMetric, setFilterMetric] = useState(handleGetOption({ option: metrics, isDefaultMetrics, type: 'defaultMetric' }));
     const [filterDimensions, setFilterDimensions] = useState(
          handleGetOption({ option: [REPORT_NAMES.BY_CONVERSION, REPORT_NAMES.BY_PROPERTY].includes(reportName) ? [...dimensions, ...newProperties] : dimensions, type: 'defaultDimension', reportName: reportName, defaultArr: defaultDimensions, reportType })
     );

     const [maxStepForm, setMaxStepForm] = useState(0);
     const [sort, setSort] = useState(
          filterMetric[0] && reportName !== REPORT_NAMES.ECOMMERCE_PURCHASE_FLOW ? { fieldName: filterMetric[0].value, isDesc: true } : {}
     );
     const [itemsPerPage, setItemsPerPage] = useState(20);
     const [isFilterConversion, setIsFilterConversion] = useState(false);
     const [offSet, setOffSet] = useState(0);
     const [fetchNextPage, setFetchNextPage] = useState(false);
     const [showChart, setShowChart] = useState(false);
     const [changeData, setChangeData] = useState(false);
     //
     const [metricDefault, setMetricDefault] = useState([]);
     const [convRate, setConvRate] = useState([]);
     const [convName, setConvName] = useState([]);
     const [weight, setWeight] = useState(defaultWeight);
     const [isDirect, setIsDirect] = useState(false);
     const [eCommerce, setECommerce] = useState([]);
     const [segmentSticky, setSegmentSticky] = useState(true);
     const [isLoading, setIsLoading] = useState(true);
     const [attributeBeforeReload, setAttributeBeforeReload] = useState({ dimensions: [], properties: [], metrics: [], scoped: '' });
     const [isRemoveCustomPropertyHaveFilter, setIsRemoveCustomPropertyHaveFilter] = useState(false);
     const { enableFullAnalytics, isRevealedCompanies, behavioralAnalytics } = activeAccount;
     const showData = localStorage.getItem('llShowData') || window.location.search.includes('show-data=1') || behavioralAnalytics || enableFullAnalytics;
     const enableRevealedCompanies =
          activeAccount.enableRevealedCompanies ||
          isRevealedCompanies ||
          localStorage.getItem('llRevealedCompany') === '1' ||
          window.location.search.includes('revealed-company=1');

     const [dateRangeConfig, setDateRangeConfig] = useState({
          comparePeriod: false,
          periodType: PERIOD_TYPES.PREVIOUS_PERIOD,
          datePreset: null,
          dateScope: initDateScope,
          sticky: true
     });

     const convertToVariableSelect = () => {
          const newArr = [];
          if (REPORT_NAMES.CONVERSION_SOURCE_ATTRIBUTION_REPORT === reportName || REPORT_NAMES.ECOMMERCE_ITEMS === reportName) {
               [...newDimensions, ...utmArray, ...eCoItemCategories].forEach((e) => {
                    const filterDimension = filterDimensions.find((item) => item.value === e.key);
                    if (filterDimension) {
                         newArr.push({ value: e.key, label: e.label });
                    }
               });
          } else {
               newDimensions.forEach((e) => {
                    if (reportName !== REPORT_NAMES.BY_LANDING_PAGE_REPORT) {
                         newArr.push({ value: e.key, label: e.label });
                    } else if (e.key !== 'pathName') {
                         newArr.push({ value: e.key, label: e.label });
                    }
               });
          }

          newProperties.forEach((e) => {
               if (customDimensionInfo.find((item) => item.properties === e.key)) {
                    newArr.push({ value: e.key, label: `${e.label}` });
               } else {
                    newArr.push({ value: e.key, label: [SECTION_REPORT.OTHER_FIELDS, SECTION_REPORT.PIPELINE_AND_STATUS].includes(e?.section) && e?.considerProperty ? `${e.label} (property)` : e.label });
               }
          });

          filterMetric.forEach((e) => {
               if (
                    reportName !== REPORT_NAMES.EVENT_DETAILS &&
                    reportName !== REPORT_NAMES.PAGE_VIEW_DETAILS &&
                    reportName !== REPORT_NAMES.FORM_SUBMISSION_EVENTS
               ) {
                    newArr.push({ value: e.value, label: e.label });
               }
          });
          FILTER_DATA_TYPES[reportName].forEach((e) => {
               if (e.type) {
                    newArr.push({ value: e.type, label: e.label });
               }
          });
          if (dataParamValue && Array.isArray(dataParamValue.filters)) {
               if (reportName === REPORT_NAMES.SESSION_DETAILS) {
                    let conversionSource = REPORT_DATA_TYPES[REPORT_NAMES.CONVERSION_SOURCE_ATTRIBUTION_REPORT][SCOPED.CONVERSION];
                    const array = [];
                    utmArray.forEach((e) => {
                         const dimension = conversionSource.dimensions.find((item) => item.label === e.key);
                         if (!dimension) {
                              array.push({ value: e.key, label: e.label });
                         }
                    });
                    const findLinkUtm = dataParamValue.filters.find((el) => array.some((e) => e.value === el.type));
                    if (findLinkUtm) {
                         newArr.push({ value: findLinkUtm.type, label: findLinkUtm.type });
                    }
               }
               if ([REPORT_NAMES.SESSION_DETAILS, REPORT_NAMES.USER_DETAILS, REPORT_NAMES.PERSON_DETAILS, REPORT_NAMES.COMPANY_DETAILS].includes(reportName) || [REPORT_TYPE.SALE_FORCE, REPORT_TYPE.CUSTOM_EXTERNAL].includes(reportType)) {
                    dataParamValue.filters.forEach((el) => {
                         let {
                              dimensions: paramDimensions = [],
                         } = REPORT_DATA_TYPES[el.reportName]?.[el.scoped] || {};
                         const externalObject = customExternalObjectReport?.find((ex) => ex?.id === el?.externalObject?.id);
                         const paramOption = paramDimensions?.find((e) => e.key === el.type);
                         if (paramOption) {
                              const index = newArr.findIndex(e => e.value === el.type);
                              if(externalObject){
                                   newArr.push({ value: el.type, label: `CRM ${externalObject?.object} ID` });
                                   return;
                              }
                              if (index !== -1) {
                                   newArr.splice(index, 1);
                              }
                              newArr.push({ value: el.type, label: paramOption?.label });
                         } else {
                              const customProperty = customDimensionsTemp?.find((e) => generateCustomDimensionName(e.name) === el.type);
                              if (customProperty) {
                                   newArr.push({ value: el.type, label: customProperty?.name });
                              } else if(externalObject){
                                   const externalUniqueIdField = externalObject?.uniqueIdFields?.find((field) => field.name === el.type);
                                   if(externalUniqueIdField){
                                        newArr.push({ value: externalUniqueIdField.name, label: `CRM ${capitalizeFirstLetter(externalUniqueIdField.label)}` });
                                   }
                              }
                         }
                    })
               }
          }
          return newArr;
     };
     const [filterOptions, setFilterOptions] = useState(convertToVariableSelect());

     useEffect(() => {
          setFilterOptions(convertToVariableSelect());
     }, [filterProperties, filterMetric, filterDimensions]); //eslint-disable-line

     useEffect(() => {
          if (externalObjectReport?.length > 0 && [REPORT_NAMES.BY_CONVERSION, REPORT_NAMES.BY_PROPERTY, ...MERGE_REPORT_NAME].includes(reportName)) {
               const activeExternalObjectMetrics = [];
               externalObjectReport
                    .filter((report) => report.appearInReport && report.object !== SALES_FORCE_OBJECT.campaignID)
                    .forEach((report) => {

                         let objectName = `${capitalizeFirstLetter(report.object)}s`;
                         if (report.object === SALES_FORCE_OBJECT.opportunityID) {
                              objectName = 'Opportunities';
                         }

                         activeExternalObjectMetrics.push(
                              { key: `active${capitalizeFirstLetter(report.object)}Count`, label: `Active ${objectName}`, isDefault: false, section: SECTION_REPORT.RELATED_OBJECTS, description: `The count of all ${objectName} that belong to these ${scoped}`, object: report.object },
                              { key: `new${capitalizeFirstLetter(report.object)}Count`, label: `New ${objectName}`, isDefault: false, section: SECTION_REPORT.RELATED_OBJECTS, description: `The count of new ${objectName} that belong to these ${scoped}`, object: report.object },
                         )
                    });
               setExternalObjectMetric(activeExternalObjectMetrics);
          }
     }, [externalObjectReport]); //eslint-disable-line

     useEffect(() => {
          if (reportName === REPORT_NAMES.ECOMMERCE_ITEMS) {
               callTokenApi(API_GET_ECO_ITEM_CATEGORIES, 'POST', { accountId }).then((response) => {
                    if (response?.status === 200) {
                         const itemCategories = response.data.itemCategories;
                         setECoItemCategories(itemCategories);
                    } else {
                         setECoItemCategories([]);
                    }
               });
          }
     }, []); //eslint-disable-line

     useEffect(() => {
          if (listSegmentReport && !recordProfile) {
               setListSegmentReportApply(listSegmentReport.filter((item) => item.apply).sort((a, b) => {
                    if (a.isCustom !== b.isCustom) {
                         return a.isCustom ? 1 : -1;
                    }
                    return new Date(a.orderBy) - new Date(b.orderBy)
               }));
          }
     }, [listSegmentReport]); //eslint-disable-line

     const [firstChangeData, setFirstChangeData] = useState(false); //eslint-disable-line

     const [filterEvent, setFilterEvent] = useState(() => {
          let filters = [];
          if (dataParamValue && Array.isArray(dataParamValue.filters)) {
               dataParamValue.filters.forEach((el) => {
                    const foundIndex = filterOptions.findIndex((filterOption) => filterOption.value === el.type);
                    const foundUtm = el.utmArray?.findIndex((utm) => utm.key === el.type);
                    const externalObject = customExternalObjectReport?.findIndex((ex) => ex?.id ===  el?.externalObject?.objectID);
                    const foundIndexCustomDimension = customDimensionsTemp.findIndex((cd) => generateCustomDimensionName(cd.name) === el.type);
                    if (el.type.includes('Custom')) {
                         filters.push(el);
                    } else if (foundIndex > -1 || foundUtm >= 0 || foundIndexCustomDimension > -1 || externalObject > -1) {
                         filters.push(el);
                    }

               });

               if (filters.length > 0) {
                    setUtmArray([
                         ...filters?.filter((filter) => filter?.utmArray?.length > 0).map((item) => {
                              return { key: item.type, label: item.type };
                         })
                    ]);
               }
          } else {
               filters = [{ type: '', value: '', id: '', operator: 'ct', optionsOperator: VARIABLE_OPERATORS_REPORT }];
          }
          return filters;
     });

     useEffect(() => {
          setFilterOptions(convertToVariableSelect());
     }, [filterProperties, scoped]); //eslint-disable-line
     useEffect(() => {
          if (recordProfile) {
               setFilterEvent(filterRecord);
               setItemsPerPage(10);
          }
     }, [recordProfile]); // eslint-disable-line react-hooks/exhaustive-deps

     const [reportData, setReportData] = useState({
          overallRowCount: 0,
          rows: [],
          res: [],
          event: [],
          totalsRow: [],
     });
     const [reportCompare, setReportCompare] = useState({ rows: undefined, res: undefined, totalsRow: undefined });
     const [filterEventReport, setFilterEventReport] = useState(false);
     const [triggerClear, setTriggerClear] = useState(false);
     const [viewLoading, setViewLoading] = useState(false);
     const [tempReport, setTempReport] = useState({ temp: ``, tempCompare: `` });
     const [exportReportTemp, setExportReportTemp] = useState({ temp: ``, tempCompare: ``, isWaiting: false, exportType: '' });
     const [tempScopedReport, setTempScopedReport] = useState({ tempScoped: ``, tempScopedCompare: `` });
     const [dimensionEvents, setDimensionEvents] = useState([]);
     const [isWebConversion, setIsWebConversion] = useState(false);
     const [staticLinkKey, setStaticLinkKey] = useState('')

     if (dataParamValue?.dateRange) {
          defaultDateRange.selection = {
               startDate: dayjs(dataParamValue.dateRange.startDate),
               endDate: dayjs(dataParamValue.dateRange.endDate),
          };
     }
     if (dataParamValue?.isDateRange) {
          defaultDateRange.selection = {
               startDate: dayjsNow.subtract(14, 'day'),
               endDate: dayjsNow.subtract(0, 'day'),
          };
     }

     const conversionNameLoading = useFirstFetchReportData({
          isConversionNameRate,
          isConversionName,
          isConversionAllReport,
          isSalesConversionName,
          scoped,
          metrics,
          reportName,
          filterMetric,
          setConversionNameMetric,
          setConversionName,
          setSort,
          setSegmentSticky,
          dataParamValue,
          recordProfile,
          dateRangeConfig,
          defaultDateRange,
          setDateRangeConfig,
          dateScopes,
          setListSegmentReportApply,
          setListChartSegmentApply,
          setDefaultConfig,
          reportViewParam,
          reportType,
          customObjectSF,
          SFObject,
     });

     const handleSetFilterDimensions = (newDimensions) => {
          setFilterDimensions(newDimensions);
     };

     const fetchDimensions = () => {
          dispatch(fetchDimensionsRequest(accountId));
     };

     const fetchScopes = () => {
          dispatch(fetchScopesRequest(accountId));
     };
     useEffect(() => {
          if (customDimensions.length === 0) {
               fetchDimensions();
          }
          if (scopes.length === 0) {
               fetchScopes();
          }
     }, [accountId]); // eslint-disable-line react-hooks/exhaustive-deps

     useEffect(() => {
          if (reportName === REPORT_NAMES.ECOMMERCE_PURCHASE_TRANSACTION) {
               const newProperties = properties.filter((_item) => !['userSourceFirst', 'userSourceLast'].includes(_item.key));
               setFilterProperties(handleGetOption({ option: newProperties }));
          }
     }, []); //eslint-disable-line

     useEffect(() => {
          setIsFilterConversion(false);
     }, [scoped]);

     useEffect(() => {
          if (filterProperties.length > 0 && filterOptions.length > 0) {
               let newOptions = [...filterEvent];
               let change = false;
               filterEvent.forEach((item) => {
                    const checkSelectCustomPropeties = filterProperties.some((el) => el.value === item.type) || customDimensionInfo.some((el) => el.properties === item.type && item?.clickable && item?.scoped === SCOPED.CONVERSION); // select custom properties
                    const checkFilterCustomPropeties = customDimensionInfo.some((el) => el.properties === item.type); // select filter custom propeties
                    if (!checkSelectCustomPropeties && checkFilterCustomPropeties && !item.clickable) {
                         newOptions = newOptions.filter((el) => el.type !== item.type);
                         change = true;
                    }
               });
               if (change) {
                    if (newOptions.length === 0) {
                         newOptions.push({
                              type: '',
                              value: '',
                              operator: 'ct',
                              optionsOperator: VARIABLE_OPERATORS_REPORT,
                         });
                    }
                    setFilterEvent(newOptions);
                    setIsRemoveCustomPropertyHaveFilter(change);
               }
          }
     }, [filterProperties]); // eslint-disable-line react-hooks/exhaustive-deps

     const newDateRange = {
          startDate: dateRangeReports.selection?.startDate.format(DEFAULT_DATE_FORMAT),
          endDate: dateRangeReports.selection?.endDate.format(DEFAULT_DATE_FORMAT),
     };

     //report view

     const [listView, setListView] = useState([]);
     const [listViewByScoped, setListViewByScoped] = useState([]);
     const [viewDefault, setViewDefault] = useState({});
     const [isMapView, setIsMapView] = useState(true);
     const [isHandleParams, setIsHandleParams] = useState(true);
     const [isApplyMetric, setIsApplyMetric] = useState(true);
     const [isLinkReport, setIsLinkReport] = useState(false);
     const [listSegmentApplyOff, setListSegmentApplyOff] = useState([]);
     const [isSaveReport, setIsSaveReport] = useState(false);

     // fetch list saved views
     const fetchSavedViews = () => {
          setViewLoading(true);

          const content = {
               filter: filterEvent,
               metrics: filterMetric.length ? filterMetric.map((_item) => _item.value) : [],
               dimensions: filterDimensions.length ? filterDimensions.map((_item) => _item.value) : [],
               properties: filterProperties.length ? filterProperties.map((_item) => _item.value) : [],
               object: reportType === REPORT_TYPE.CUSTOM_EXTERNAL ? SFObject : customObjectSF,
          };
          callTokenApi(`${CLIENT_GET_SAVED_VIEWS}`, 'POST', {
               accountId: activeAccount.accountId,
               userId: user.id,
               reportName,
               scoped,
               content: JSON.stringify(content),
               shareLink: `${location.pathname.replace(`/${activeAccount.secondId}`, '')}`,
               object: reportType === REPORT_TYPE.CUSTOM_EXTERNAL ? SFObject : customObjectSF,
               reportType,
               externalObject,
          }).then((response) => {
               if (response.status === 200) {
                    const reportViews = response.data.reportViews;
                    setViewLoading(false);

                    const isFilter = !dataParamValue;
                    const findViewDefault = reportViews.find(_item => _item.isDefault) || reportViews.find(_item => _item.isSystem);
                    if (findViewDefault) {
                         setViewDefault(findViewDefault);
                         setFilterViewDefault(findViewDefault, isFilter);
                         if (findViewDefault.isSystem) {
                              const newReportViews = reportViews.map((_view) => {
                                   if (_view.id === findViewDefault.id) {
                                        return { ..._view, isDefault: true }
                                   }
                                   return _view;
                              });
                              setListView(newReportViews);
                         } else {
                              setListView(reportViews);
                         }
                    }

                    if (dataParamValue) {
                         const contentFilter = dataParamValue.filters.length
                              ? dataParamValue.filters.map((_param) => ({
                                   type: _param.type,
                                   value: _param.value,
                                   id: '',
                                   operator: _param.operator,
                                   optionsOperator: _param.optionsOperator,
                              }))
                              : [];

                         for (const _item of reportViews) {
                              const itemFilter = [];

                              for (const _filter of _item.content.filter) {
                                   itemFilter.push({
                                        type: _filter.type,
                                        value: _filter.value,
                                        id: '',
                                        operator: _filter.operator,
                                        optionsOperator: _filter.optionsOperator,
                                   });
                              }

                              const content = JSON.stringify(contentFilter);
                              const itemContent = JSON.stringify(itemFilter);

                              if (content === itemContent) {
                                   setFilterViewDefault(_item, isFilter);
                                   setIsMapView(true);

                                   break;
                              } else {
                                   setIsLinkReport(true)
                                   setIsMapView(false);
                              }
                         }
                    }
               }
          });
     };

     //get list view by scoped
     useEffect(() => {
          if (listView.length > 0) {
               const scopedApplyReport = (reportViewParam && reportView?.scoped) || scoped;
               const newListViewByScoped = listView.filter((_view) => _view.scoped === scopedApplyReport);
               setListViewByScoped(newListViewByScoped);
          }
     }, [listView]); // eslint-disable-line

     const getReportValue = (scoped) => {
          let { dimensions, properties, metrics } = reportType ? REPORT_DATA_TYPES[reportName][scoped] : REPORT_DATA_TYPES[reportName];
          const { newProperties, newDimensions } = getDynamicFieldInReport({
               dimensions,
               properties,
               customDimensionsTemp,
               reportName,
               scoped,
               scopes,
               showTargetAccount,
               listDynamicFields,
               reportType,
               customObjectSF,
               listSegmentReportApply,
               filterProperties,
               setFilterProperties,
               filterLinks: dataParamValue && Array.isArray(dataParamValue?.filters) ? dataParamValue?.filters : [],
               intentProperties,
               customDimensionIds,
               externalObject,
               propertiesOptional,
               metricsOptional,
          });

          if (!showTargetAccount) {
               properties = properties.filter((item) => !['isTargetAccount', 'targetAccountDomain'].includes(item.key))
          }

          if (reportName === REPORT_NAMES.ECOMMERCE_ITEMS) {
               dimensions = [...dimensions, ...eCoItemCategories];
          }

          const {dimensionsDefault, propertiesDefault, metricsDefault} = getDefaultFieldReport({ reportType, reportName, scoped, weight, utmArray, properties: newProperties, dimensions: newDimensions, objectID, eCoItemCategories, customExternalObjectReport, handleGetOption });
          
          const metricDynamic = listDynamicFields?.metrics?.length > 0 ? listDynamicFields?.metrics : [];
          dimensions = handleGetOption({ option: dimensionsDefault, reportName });
          properties = handleGetOption({ option: propertiesDefault, type: 'option', filter: [] });
          metrics = handleGetOption({ option: [...metricsDefault, ...conversionNameMetric, ...metricsStepForm, ...externalObjectMetric, ...metricDynamic] });

          return {
               dimensions,
               properties,
               metrics,
          };
     };

     const sortAndFilterArray = (referenceArray, targetArray) => {
          targetArray.sort((a, b) => {
               const indexA = referenceArray.indexOf(a.value);
               const indexB = referenceArray.indexOf(b.value);

               if (indexA === -1 && indexB === -1) return 0;
               if (indexA === -1) return 1;
               if (indexB === -1) return -1;

               return indexA - indexB;
          });
          return targetArray.filter((item) => referenceArray.includes(item.value));
     };

     //set (dimensions, properties, metric, filter) with view
     const setFilterViewDefault = (viewDefault, isFilter = true, isApplyMetric = true, isFetchReport = true) => {
          if (viewDefault && Object.keys(viewDefault).length > 0) {
               setViewDefault(viewDefault);
               const content = viewDefault.content;
               const reportValue = getReportValue(viewDefault.scoped);

               setFilterDimensions(sortAndFilterArray(content.dimensions, reportValue.dimensions));
               setFilterProperties(sortAndFilterArray(content.properties, reportValue.properties));
               if (isApplyMetric) {
                    setFilterMetric(sortAndFilterArray(content.metrics, reportValue.metrics));
               }

               if (content.weight) {
                    setIsDirect(content.weight.noneDirect);
                    setWeight(content.weight);
               }

               if (isFilter && !recordProfile) {
                    if (content.filter?.length) {
                         content.filter.forEach((item, index) => {
                              delete item.scoped
                              delete item.tempScopedReport

                              if (dataParamValue?.filters && Array.isArray(dataParamValue.filters)) {
                                   const findFilter = dataParamValue.filters.find((filter) => filter.type === item.type);
                                   if (findFilter) {
                                        item.scoped = findFilter.scoped;
                                        item.tempScopedReport = findFilter.tempScopedReport;
                                   }
                              }
                         })
                    }
                    setFilterEvent(content.filter);
               }

               if (isFetchReport) {
                    setFilterEventReport(!filterEventReport);
               }
               setScoped(viewDefault.scoped);
               setUnRelated(content.unRelated);
               setIsMapView(true);
          }
     };

     useEffect(() => {
          if (!customDimensions) return;
          const listCustomPropertyEvent = customDimensions.filter((item) =>
               item.availableScopes.some((scope) => scope.isWebConversion && filterProperties.some((option) => option.label === item.name))
          );
          setDimensionEvents(listCustomPropertyEvent);
          if (listCustomPropertyEvent?.length > 0) {
               setIsWebConversion(true);
          } else {
               setIsWebConversion(false);
          }
     }, [customDimensions, filterProperties]); // eslint-disable-line react-hooks/exhaustive-deps

     //handle with param reportView
     const handleParamsReportView = (reportView) => {
          if (Object.keys(reportView).length > 0) {
               const viewContent = reportView.content;
               const dateRangeConfig = viewContent.dateRangeConfig
               let newDateRange
               let newConfig

               const isSaveReport = reportView.type === VIEW_TYPE.REPORT
               setIsSaveReport(isSaveReport);

               if (dateRangeConfig && isSaveReport) {
                    const aiStartDate = new URLSearchParams(location.search).get('startDate');
                    const aiEndDate = new URLSearchParams(location.search).get('endDate');

                    const { type, dateRanges: dateRangesStatic, dateScope, rolling, sticky } = dateRangeConfig;
                    switch (type) {
                         case SAVE_REPORT_DATE_OPTION.NO_RANGE:
                              const dateRangeSession = localStorage.getItem(SESSION_STORAGE_REPORT_DATE_RANGE) ? JSON.parse(localStorage.getItem(SESSION_STORAGE_REPORT_DATE_RANGE)) : null;
                              if (dateRangeSession && !isEmpty(dateRangeSession)) {
                                   newDateRange = {
                                        ...(dateRangeSession.compare && {
                                             compare: {
                                                  startDate: dayjs(dateRangeSession.compare.startDate),
                                                  endDate: dateRangeSession.compare.endDate ? dayjs(dateRangeSession.compare.endDate) : dayjs(dateRangeSession.compare.startDate),
                                             },
                                        }),
                                        selection: {
                                             startDate: dayjs(dateRangeSession.selection.startDate),
                                             endDate: dateRangeSession.selection.endDate ? dayjs(dateRangeSession.selection.endDate) : dayjs(dateRangeSession.selection.startDate),
                                        },
                                   };
                                   newConfig = { comparePeriod: dateRangeSession.compare, datePreset: dateRangeSession.datePreset, periodType: dateRangeSession.periodType, sticky }
                                   dispatch(setDateRangeReports(newDateRange));
                                   setDateRangeConfig((prev) => ({ ...prev, ...newConfig }));
                              }
                              break;
                         case SAVE_REPORT_DATE_OPTION.STATIC_RANGE:
                              if (dateRangesStatic) {
                                   newDateRange = {
                                        ...(dateRangesStatic.compare && {
                                             compare: {
                                                  startDate: dayjs(dateRangesStatic.compare.startDate),
                                                  endDate: dateRangesStatic.compare.endDate ? dayjs(dateRangesStatic.compare.endDate) : dayjs(dateRangesStatic.compare.startDate),
                                             },
                                        }),
                                        selection: {
                                             startDate: dayjs(dateRangesStatic.selection.startDate),
                                             endDate: dateRangesStatic.selection.endDate ? dayjs(dateRangesStatic.selection.endDate) : dayjs(dateRangesStatic.selection.startDate),
                                        },
                                   };
                                   dispatch(setDateRangeReports(newDateRange));
                                   newConfig = { dateScope: dateScope, comparePeriod: dateRangesStatic.compare, datePreset: dateRangesStatic.datePreset, periodType: dateRangesStatic.periodType, sticky }
                                   setDateRangeConfig((prev) => ({ ...prev, ...newConfig }));

                                   localStorage.setItem(SESSION_STORAGE_REPORT_DATE_RANGE, JSON.stringify({ ...newConfig, ...newDateRange }));
                              }
                              break;
                         case SAVE_REPORT_DATE_OPTION.ROLLING_RANGE:
                              if (rolling) {
                                   const { type: rollingType, numberPrevious, isComparison, periodType, customDateCompare } = rolling;
                                   const lastWeek = dayjsNow.subtract(1, 'week');
                                   const lastMonth = dayjsNow.subtract(1, 'month');
                                   const lastDay = dayjsNow['$D'] === 1 ? dayjsNow.subtract(1, 'day') : dayjsNow;
                                   switch (rollingType) {
                                        case ROLLING_DATE_RANGE.previous_week_mon_sun:
                                             newDateRange = {
                                                  selection: {
                                                       startDate: aiStartDate ? dayjs(aiStartDate) : dayjs(lastWeek.startOf('week')).add(1, 'day'),
                                                       endDate: aiEndDate ? dayjs(aiEndDate) : dayjs(lastWeek.endOf('week')).add(1, 'day')
                                                  }
                                             };
                                             break;
                                        case ROLLING_DATE_RANGE.previous_week_sat_sun:
                                             newDateRange = {
                                                  selection: {
                                                       startDate: aiStartDate ? dayjs(aiStartDate) : dayjs(lastWeek.startOf('week')).add(6, 'day'),
                                                       endDate: aiEndDate ? dayjs(aiEndDate) : dayjs(lastWeek.endOf('week')).add(1, 'day')
                                                  }
                                             };
                                             break;
                                        case ROLLING_DATE_RANGE.previous_week_fri_sun:
                                             newDateRange = {
                                                  selection: {
                                                       startDate: aiStartDate ? dayjs(aiStartDate) : dayjs(lastWeek.startOf('week')).add(5, 'day'),
                                                       endDate: aiEndDate ? dayjs(aiEndDate) : dayjs(lastWeek.endOf('week')).add(1, 'day')
                                                  }
                                             };
                                             break;
                                        case ROLLING_DATE_RANGE.previous_week_sun_sat:
                                             newDateRange = {
                                                  selection: {
                                                       startDate: aiStartDate ? dayjs(aiStartDate) : dayjs(lastWeek.startOf('week')),
                                                       endDate: aiEndDate ? dayjs(aiEndDate) : dayjs(lastWeek.endOf('week'))
                                                  }
                                             };
                                             break;
                                        case ROLLING_DATE_RANGE.previous_month:
                                             newDateRange = {
                                                  selection: {
                                                       startDate: aiStartDate ? dayjs(aiStartDate) : dayjs(lastMonth.startOf('month')),
                                                       endDate: aiEndDate ? dayjs(aiEndDate) : dayjs(lastMonth.endOf('month'))
                                                  }
                                             };
                                             break;
                                        case ROLLING_DATE_RANGE.month_to_date_yesterday:
                                             newDateRange = {
                                                  selection: {
                                                       startDate: aiStartDate ? dayjs(aiStartDate) : dayjs(lastDay.startOf('month')),
                                                       endDate: aiEndDate ? dayjs(aiEndDate) : dayjs(dayjsNow).subtract(1, 'day'),
                                                  }
                                             };
                                             break;
                                        case ROLLING_DATE_RANGE.year_to_date_yesterday:
                                             newDateRange = {
                                                  selection: {
                                                       startDate: aiStartDate ? dayjs(aiStartDate) : dayjs(lastDay.startOf('year')),
                                                       endDate: aiEndDate ? dayjs(aiEndDate) : dayjs(dayjsNow).subtract(1, 'day'),
                                                  }
                                             };
                                             break;
                                        case ROLLING_DATE_RANGE.previous_x_days:
                                             newDateRange = {
                                                  selection: {
                                                       startDate: aiStartDate ? dayjs(aiStartDate) : dayjs(dayjsNow).subtract(numberPrevious, 'day'),
                                                       endDate: aiEndDate ? dayjs(aiEndDate) : dayjs(dayjsNow).subtract(1, 'day'),
                                                  }
                                             };
                                             break;
                                        case ROLLING_DATE_RANGE.previous_x_weeks:
                                             newDateRange = {
                                                  selection: {
                                                       startDate: aiStartDate ? dayjs(aiStartDate) : dayjs(dayjsNow).subtract(numberPrevious, 'week'),
                                                       endDate: aiEndDate ? dayjs(aiEndDate) : dayjs(dayjsNow).subtract(1, 'day'),
                                                  }
                                             };
                                             break;
                                        case ROLLING_DATE_RANGE.quarter_to_date:
                                             newDateRange = {
                                                  selection: {
                                                       startDate: aiStartDate ? dayjs(aiStartDate) : dayjs(lastDay.startOf('quarter')),
                                                       endDate: aiEndDate ? dayjs(aiEndDate) : dayjs(dayjsNow).subtract(1, 'day'),
                                                  }
                                             };
                                             break;

                                        default:
                                             break;
                                   }

                                   if (isComparison) {
                                        const startDateSelection = dayjs(newDateRange.selection.startDate);
                                        const endDateSelection = dayjs(newDateRange.selection.endDate);
                                        const selectionDateSubtract = Math.floor((endDateSelection - startDateSelection) / (1000 * 3600 * 24));
                                        switch (periodType) {
                                             case PERIOD_TYPES.PREVIOUS_PERIOD:
                                                  newDateRange.compare = {
                                                       startDate: startDateSelection.subtract(1, 'day').subtract(selectionDateSubtract, 'day'),
                                                       endDate: startDateSelection.subtract(1, 'day')
                                                  }
                                                  break;

                                             case PERIOD_TYPES.PREVIOUS_YEAR:
                                                  newDateRange.compare = {
                                                       startDate: startDateSelection.subtract(1, 'year'),
                                                       endDate: endDateSelection.subtract(1, 'year')
                                                  }
                                                  break;
                                             case PERIOD_TYPES.CUSTOM:
                                                  if (customDateCompare) {
                                                       newDateRange.compare = {
                                                            startDate: dayjs(customDateCompare.selection.startDate),
                                                            endDate: customDateCompare.selection.endDate ? dayjs(customDateCompare.selection.endDate) : dayjs(customDateCompare.selection.startDate),
                                                       }
                                                  }

                                                  break;

                                             case PERIOD_TYPES_NEW.PREVIOUS_MONTH:
                                                  newDateRange.compare = {
                                                       startDate: startDateSelection.subtract(1, 'month'),
                                                       endDate: endDateSelection.subtract(1, 'month')
                                                  }

                                                  break;

                                             case PERIOD_TYPES_NEW.PREVIOUS_QUARTER:
                                                  const startQuarter = startDateSelection.subtract(1, 'quarter')
                                                  const endQuarter = startQuarter.add(selectionDateSubtract, 'day')
                                                  newDateRange.compare = {
                                                       startDate: startQuarter,
                                                       endDate: startQuarter.quarter() === endQuarter.quarter() ? endQuarter : startQuarter.endOf('quarter')
                                                  }

                                                  break;

                                             default:
                                                  break;
                                        }
                                   }
                                   dispatch(setDateRangeReports(newDateRange));

                                   newConfig = { dateScope: dateScope, comparePeriod: !!newDateRange.compare, periodType, sticky }
                                   setDateRangeConfig((prev) => ({ ...prev, ...newConfig }));
                              }
                              break;

                         default:
                              break;
                    }

                    if (!aiStartDate) {
                         localStorage.setItem(SESSION_STORAGE_REPORT_DATE_RANGE, JSON.stringify({ ...newConfig, ...newDateRange }));
                    }

                    if (sticky) {
                         const dateRangeConfigSave = { ...dateRangeConfig, ...newConfig, ...newDateRange };
                         const data = {
                              accountId,
                              reportName,
                              reportType,
                              dateRangeConfig: dateRangeConfigSave,
                              userId: user.id,
                              isSaveReport,
                              currentSticky: defaultConfig.dateRangeSticky,
                              object: SFObject,
                              externalObjectReport: [...externalObjectReport, ...customExternalObjectReport.map((el) => { return { object: el.object, appearInReport: el.appearInReport, characteristicOtherObject: el.characteristicOtherObject } })],
                         };
                         if (!aiStartDate) {
                              callTokenApi(`${API_CLIENT_DEFAULT_REPORT_DATE_RANGE_CONFIGS}`, 'PUT', data);
                         }
                    }
               }

               if (isSaveReport) {
                    const viewId = reportView.viewId;
                    const segments = viewContent.segment ?? [];

                    if (listSegmentReport.length > 0) {
                         const newSegments = listSegmentReport.map((item) => ({ ...item, apply: segments.includes(item.id) }));

                         const listSegmentApplyOff = listSegmentReport
                              .filter((segment) => {
                                   const findNewSegment = newSegments.find((_item) => _item.id === segment.id && !_item.apply);
                                   return segment.apply && findNewSegment;
                              })
                              .map((segment) => {
                                   return {
                                        id: segment.id,
                                        segmentReportId: segment.segmentReportId,
                                        apply: false,
                                        applyChart: false,
                                        type: 'update',
                                   };
                              });

                         setListSegmentApplyOff(listSegmentApplyOff);

                         dispatch(setListSegmentReport(newSegments));
                         setSort(
                              handleGetSortSegment({
                                   listSegmentReportApply: listSegmentReport
                                        .filter((item) => segments.includes(item.id))
                                        .filter((item) => item.queryStatus === BQ_JOB_STATUS.DONE),
                                   filterMetric,
                              })
                         );

                         setListSegmentReportApply(
                              listSegmentReport
                                   .filter((item) => segments.includes(item.id))
                                   .sort((a, b) => {
                                        if (a.isCustom !== b.isCustom) {
                                             return a.isCustom ? 1 : -1;
                                        }
                                        return new Date(a.orderBy) - new Date(b.orderBy);
                                   })
                         );

                         setSegmentSticky(viewContent.segmentSticky);
                    }

                    if (viewId) {
                         setScoped(reportView.scoped);

                         const findView = listViewByScoped.find((view) => view.id === viewId);
                         if (findView) {
                              setFilterViewDefault(findView);
                              setIsMapView(true);
                         }
                         return;
                    }
               }

               const reportValue = getReportValue(reportView.scoped);

               const dimensionValue = sortAndFilterArray(viewContent.dimensions, reportValue.dimensions);
               const propertyValue = sortAndFilterArray(viewContent.properties, reportValue.properties);
               const metricValue = sortAndFilterArray(viewContent.metrics, reportValue.metrics);
               const payload = {
                    filter: viewContent.filter,
                    metrics: metricValue.length ? metricValue.map((_item) => _item.value) : [],
                    dimensions: dimensionValue.length ? dimensionValue.map((_item) => _item.value) : [],
                    properties: propertyValue.length ? propertyValue.map((_item) => _item.value) : [],
                    ...(viewContent.weight && { weight: viewContent.weight }),
               };

               if (customObjectSF) {
                    payload.object = customObjectSF
               }
               const content = JSON.stringify(payload);

               const isViewMatched = listViewByScoped.some((view) => {
                    const newContent = view.content;
                    const itemContent = JSON.stringify(newContent);
                    if (content === itemContent) {
                         setFilterViewDefault(view);
                         return true;
                    }
                    return false;
               });

               if (isViewMatched) {
                    setIsMapView(true);
               } else {
                    setScoped(reportView.scoped);
                    if (!recordProfile) {
                         setFilterEvent(viewContent.filter);
                    }
                    if (viewContent.weight) {
                         setIsDirect(viewContent.weight.noneDirect);
                         setWeight(viewContent.weight);
                    }
                    setFilterDimensions(reportValue.dimensions.filter((dim) => viewContent.dimensions.includes(dim.value)));
                    setFilterProperties(reportValue.properties.filter((prop) => viewContent.properties.includes(prop.value)));
                    setFilterMetric(reportValue.metrics.filter((metric) => viewContent.metrics.includes(metric.value)));
                    setIsMapView(false);
               }
          }
     };

     //fetch view default
     const fetchReportViewById = () => {
          const idViewReport = parseParams.id;
          const query = `?id=${idViewReport}`;

          return callTokenApi(`${CLIENT_GET_SAVED_REPORT_BY_ID}/${query}`, 'GET').then((response) => {
               if (response.status === 200) {
                    const reportView = response.data.reportViews;
                    if (reportView) {
                         if (!reportView.isSystem && ((reportView.isAvailable && accountId !== reportView.accountId) || (!reportView.isAvailable && reportView.userId !== user.id))) {
                              history.push("/");
                         }
                         setReportView(reportView);
                         handleParamsReportView(reportView);
                    }
               }
          });
     };

     //handle find view when change element(dimensions, properties, metric, filter)
     const handleFindView = (type, values, isFetchReport = true) => {
          let dimensions = filterDimensions;
          let filter = filterEvent;
          let metrics = filterMetric;
          let properties = filterProperties;
          let currentUnRelated = unRelated;
          let weightData = {
               ...weight,
               noneDirect: isDirect,
          };

          if (type === REPORT_TAB_TYPES.FILTER) {
               filter = values;
          }

          if (type === REPORT_TAB_TYPES.DIMENSIONS) {
               if (!values.length) {
                    dimensions = [values];
               } else {
                    dimensions = values;
               }
          }

          if (type === REPORT_TAB_TYPES.METRICS) {
               metrics = values;
          }

          if (type === REPORT_TAB_TYPES.PROPERTIES) {
               properties = values;
          }

          if (type === REPORT_TAB_TYPES.MODEL) {
               weightData = {
                    ...values,
               };
          }

          if (type === REPORT_TAB_TYPES.UNRELATED) {
               currentUnRelated = values;
          }

          const payload = {
               filter: filter,
               metrics: metrics.length ? metrics.map((_item) => _item.value) : [],
               dimensions: dimensions.length ? dimensions.map((_item) => _item.value) : [],
               properties: properties.length ? properties.map((_item) => _item.value) : [],
               ...(weight && { weight: weightData }),
               unRelated: currentUnRelated
          };

          const content = JSON.stringify(payload);
          for (const _item of listViewByScoped) {
               const itemContent = JSON.stringify(_item.content);
               if (content === itemContent) {
                    setFilterViewDefault(_item, true, true, isFetchReport);
                    break;
               } else {
                    setIsMapView(false);
               }
          }
     };

     useEffect(() => {
          if (!recordProfile) {
               const init = async () => {
                    if (Object.keys(reportView).length === 0 && reportViewParam) {
                         await fetchReportViewById();
                    }

                    if (!listView.length) {
                         fetchSavedViews();
                    }
               };
               init();
          }
     }, []); // eslint-disable-line

     //update custom dimensions, properties, metric

     useEffect(() => {
          if (!recordProfile && listViewByScoped.length > 0) {
               if (reportViewParam) {
                    if (Object.keys(reportView).length && isHandleParams) {
                         handleParamsReportView(reportView);
                    }
               } else if (Object.keys(viewDefault).length > 0 && (isMapView || isLinkReport)) {
                         const content = viewDefault.content;
                         const reportValue = getReportValue(viewDefault.scoped);
                         setFilterDimensions(sortAndFilterArray(content.dimensions, reportValue.dimensions));
                         setFilterProperties(sortAndFilterArray(content.properties, reportValue.properties));
                         if (isApplyMetric) {
                              setFilterMetric(sortAndFilterArray(content.metrics, reportValue.metrics));
                         }
                    }
          }
     }, [eCoItemCategories, scopes, JSON.stringify(metricsStepForm), listViewByScoped, reportView, conversionNameMetric, externalObjectMetric, primaryObject, secondaryObject, salesConversionName, JSON.stringify(listDynamicFields)]); // eslint-disable-line

     const contextValue = {
          reportName,
          filterMetric,
          setFilterMetric,
          handleGetOption,
          filterDimensions,
          setFilterDimensions: handleSetFilterDimensions,
          filterProperties,
          setFilterProperties,
          filterEvent,
          setFilterEvent,
          setReportData,
          reportData,
          setFilterEventReport,
          filterEventReport,
          isLoading,
          setIsLoading,
          dateRangeConfig,
          setDateRangeConfig,
          filterOptions,
          tableData,
          setTableData,
          sort,
          setSort,
          itemsPerPage,
          setItemsPerPage,
          offSet,
          setOffSet,
          scoped,
          setScoped,
          reportType,
          showChart,
          setShowChart,
          conversionNameMetric,
          conversionName,
          dateScopeOptions,
          isFilterConversion,
          setIsFilterConversion,
          reportCompare,
          setReportCompare,
          fetchNextPage,
          setFetchNextPage,
          showData,
          enableFullAnalytics,
          enableRevealedCompanies,
          changeData,
          setChangeData,
          recordProfile,
          newProperties,
          newDimensions,
          customDimensionInfo,
          metricsStepForm,
          setMetricsStepForm,
          metricDefault,
          setMetricDefault,
          convRate,
          setConvRate,
          convName,
          setConvName,
          eCommerce,
          setECommerce,
          setFirstChangeData,
          isRemoveCustomPropertyHaveFilter,
          setIsRemoveCustomPropertyHaveFilter,
          dataParamValue,
          isChangeScope,
          newDateRange,
          weight,
          setWeight,
          utmArray,
          setUtmArray,
          maxStepForm,
          setMaxStepForm,
          triggerClear,
          setTriggerClear,
          eCoItemCategories,
          isDirect,
          setIsDirect,
          attributeBeforeReload,
          setAttributeBeforeReload,
          listSegment,
          listSegmentReport,
          listSegmentReportApply,
          setListSegmentReportApply,
          listView,
          setListView,
          listViewByScoped,
          setListViewByScoped,
          viewDefault,
          setViewDefault,
          setFilterViewDefault,
          isMapView,
          setIsMapView,
          handleFindView,
          setIsHandleParams,
          setIsApplyMetric,
          viewLoading,
          tempReport,
          setTempReport,
          isFecthTableEvent,
          segmentSticky,
          setSegmentSticky,
          disableSort,
          reloadTable,
          setReloadTable,
          tempScopedReport,
          setTempScopedReport,
          listChartSegmentApply,
          setListChartSegmentApply,
          isWebConversion,
          dimensionEvents,
          reportView,
          defaultConfig,
          isSaveReport,
          listDynamicFields,
          externalObjectMetric,
          unRelated,
          setUnRelated,
          customObjectSF,
          primaryObject,
          secondaryObject,
          salesConversionName,
          salesConversionDimension,
          customDimensionIds,
          saleConversionDimensionClick,
          payloadReportExplorer,
          setPayloadReportExplorer,
          payloadReportFilter,
          setPayloadReportFilter,
          SFObject,
          intentProperties,
          dateScopes,
          reportDetailData,
          objectID,
          exportReportTemp,
          setExportReportTemp,
          staticLinkKey,
          setStaticLinkKey,
          rerunValueChange,
          setRerunValueChange,
          salesForceObjects,
          customExternalObjects,
     };
     if (recordProfile && !isFecthTableEvent) return;

     const titleStyle = ['Event Details', 'Conversion Events', 'Session Details', 'User Details', 'People Details'];

     return (
          <div className="analytics not-container">
               {conversionNameLoading ? (
                    <div className="page-loading-container">
                         <CenterSpinner />
                    </div>
               ) : (
                    <EventExplorerContext.Provider value={contextValue}>
                         <div className="report-header d-flex align-items-center justify-content-between">
                              <p className="report-title">{title}</p>
                              <div className="d-flex align-items-center">
                                   {!recordProfile && (
                                        <>
                                             <div className={`header-item ${titleStyle.includes(title) ? 'no-scope-dropdown' : ''}`}>
                                                  <AddSegments listSegmentApplyOff={listSegmentApplyOff} />
                                             </div>
                                             {reportType && (
                                                  <div className="header-item">
                                                       <ScopeDropdown />
                                                  </div>
                                             )}
                                             <div className="header-item">
                                                  <CustomDatePicker />
                                             </div>
                                        </>
                                   )}
                              </div>
                         </div>

                         {showNewNavigation && (
                              <CSubheader className="main-breadcrumb justify-content-between">
                                   <BreadcrumbRouter
                                        className="border-0 c-subheader-nav m-0 px-4 px-md-3 d-flex align-items-center"
                                        routes={routes}
                                   />
                              </CSubheader>
                         )}

                         {showChart && <ChartReport />}

                         <MenuReport />
                         <ReportTableV2 />
                    </EventExplorerContext.Provider>
               )}
          </div>
     );
};

EventExplorer.propTypes = {
     title: PropTypes.string,
     reportName: PropTypes.string,
     filterRecord: PropTypes.any,
     recordProfile: PropTypes.any,
     reportType: PropTypes.string,
     isFecthTableEvent: PropTypes.bool,
};

export default EventExplorer;
